import { useEffect, useState } from "react";
import { Alert, Button, Content, ContentLoader, Icon, Input, LoadingSpinner, Table } from "@webtypen/react-components";
import { ApiHelper, ConfirmHelper } from "../helpers";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

export const ContractShiftEdit = ({ onSave }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [hasSucces, setHasSuccess] = useState(false);
    const [removedIds, setRemovedIds] = useState([]);
    const [data, setData] = useState(null);

    const add = () => {
        const newData = data && data.length > 0 ? [...data] : [];
        newData.push({ _id: "new", name: "" });
        setData(newData);
    };

    const onChange = (e) => {
        const newData = [...data];
        newData[parseInt(e.target.getAttribute("data-index"))][e.target.name] = e.target.value;
        setData(newData);
    };

    const onRemove = (e) => {
        if (
            data[parseInt(e.currentTarget.getAttribute("data-index"))] &&
            data[parseInt(e.currentTarget.getAttribute("data-index"))]._id !== "new"
        ) {
            const newRemovedIds = [...removedIds];
            newRemovedIds.push(data[parseInt(e.currentTarget.getAttribute("data-index"))]._id + "");
            setRemovedIds(newRemovedIds);
        }

        const newData = [...data];
        newData.splice(parseInt(e.currentTarget.getAttribute("data-index")), 1);
        setData(newData);
    };

    const submit = (e) => {
        e.preventDefault();

        setIsSaving(true);
        ApiHelper.request("/api/contracts/shifts/types/save", { entries: data, removed: removedIds })
            .then((response) => {
                setIsSaving(false);
                if (response.status === "success") {
                    setHasSuccess(true);

                    if (onSave) {
                        onSave();
                    }
                } else {
                    ConfirmHelper.alert(
                        response.status === "error" && response.message && response.message.trim() !== ""
                            ? response.message
                            : "Es ist ein unerwarteter Fehler aufgetreten ..."
                    );
                }
            })
            .catch((e) => {
                console.error(e);

                ConfirmHelper.alert(
                    e && e.data && e.data.status === "error" && e.data.message && e.data.message.trim() !== ""
                        ? e.data.message
                        : "Es ist ein unerwarteter Fehler aufgetreten ..."
                );
                setIsSaving(false);
            });
    };

    const load = () => {
        setIsLoading(true);
        ApiHelper.request("/api/contracts/shifts/types/list")
            .then((response) => {
                setData(
                    response.status === "success" && response.data && response.data.length > 0 ? response.data : null
                );
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setData(null);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        load();
    }, []);

    if (isLoading) {
        return (
            <Content>
                <ContentLoader />
            </Content>
        );
    }

    return (
        <form onSubmit={submit}>
            {hasSucces ? (
                <Content>
                    <Alert success>Schicht-Typen wurden erfolgreich gespeichert ...</Alert>
                </Content>
            ) : null}

            <Table>
                <tbody>
                    {data && data.length > 0 ? (
                        data.map((entry, i) => (
                            <tr key={i}>
                                <td style={{ width: 50 }}>
                                    <Button
                                        type="button"
                                        data-index={i}
                                        onClick={onRemove}
                                        disabled={isSaving}
                                        danger
                                        sm
                                    >
                                        <Icon icon={faTrash} />
                                    </Button>
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={entry.name ? entry.name : ""}
                                        data-index={i}
                                        onChange={onChange}
                                        disabled={isSaving}
                                    />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td className="text-center">Es wurden noch keine Schicht-Typen angelegt ...</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <Content className="pt-1">
                <Button disabled={isSaving} className="float-right" success sm>
                    {isSaving ? <LoadingSpinner /> : "Speichern"}
                </Button>

                <Button type="button" disabled={isSaving} onClick={add} light sm>
                    <Icon icon={faPlus} className="mr-1" />
                    Hinzufügen
                </Button>
            </Content>
        </form>
    );
};
